import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFormByID,getAllFroms,saveFrom } from "api/formsApi";
import { logger } from "helpers/logger";

export const fetchFormByID = createAsyncThunk("form/fetchFormByID", async ({ form_key, pageNumber, formData, readonly, startingPage }, { rejectWithValue, signal }) => {
	try {
		const response = await getFormByID({ form_key, pageNumber, formData, readonly, startingPage }, signal);
		return response;
	} catch (error) {
		if (error.name === "AbortError") {
			logger.info("🚫 Request cancelled");
			return rejectWithValue("cancelled");
		}
		logger.error("❌ Failed to fetch form:", error);
		return rejectWithValue(error.message || "Failed to fetch form");
	}
});

export const fetchgetAllFroms = createAsyncThunk("forms/fetchgetAllFroms", async (params = {}, { rejectWithValue, signal }) => {
    try {
        const response = await getAllFroms(params, signal);

        if (!response || response.statusCode !== 200) {
            return rejectWithValue(response?.message || "API Error");
        }

        let parsedForms = [];
        if (response?.data?.formData) {
            parsedForms = JSON.parse(response.data.formData);
        }

        return {
            formData: parsedForms,
            currentPageNumber: response.data.currentPageNumber,
        };
    } catch (error) {
        if (error.name === "AbortError") return rejectWithValue("cancelled");
        logger.error("THUNK ERROR:", error);
        return rejectWithValue(error.message || "Failed to fetch forms");
    }
});
export const postsaveform = createAsyncThunk(
  "forms/postsaveform",
  async ({ form_key, formData }, { rejectWithValue, signal }) => {
    try {
      const response = await saveFrom({ form_key, data: formData }, signal);

      if (!response || response.statusCode !== 200) {
        return rejectWithValue(response?.message || "API Error");
      }

      return { data: response.data }; // pass back saved data
    } catch (error) {
      if (error.name === "AbortError") return rejectWithValue("cancelled");
      logger.error("THUNK ERROR:", error);
      return rejectWithValue(error.message || "Failed to save form");
    }
  }
);	